import OrderHistoryModal from "./order-history-modal.component";

export default OrderHistoryModal;
